<template>
  <div>
    <Navbar v-if="this.$route.name == 'gdqsettings'"/>
    <Breadcrumb v-if="this.$route.name == 'gdqsettings'" />    
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="money-bill"
            />Pricing
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <b-row>
            <b-form-group 
              label-cols="4"
              label="VAT rate (%)"
              class="col-12"
            >
              <b-form-input  
                id="gdq_vat" 
                class="form-control col-7"
                v-model="gdq_vat"
                v-on:change="savepref('gdq_vat',gdq_vat)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group 
              label-cols="4"
              label="GDQ Report price per survey"
              class="col-12"
            >
              <b-form-input  
                id="gdqreport_price" 
                class="form-control col-7"
                v-model="gdqreport_price"
                v-on:change="savepref('gdqreport_price',gdqreport_price)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"            
              name="envelope"
            />Invitations
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <DefaultMailTexts />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="tasks"
            />GDQ Questions
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_questions" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="file-alt"
            />Questionnaire Texts
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_questionnairetexts" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="print"
            />Report Texts
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_reporttexts" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="check"
            />Certification
          </div>
        </template>
        <b-card no-body class="border-0 mx-4 px-0 pl-0 pr-0 col-12">
          <b-row>
            <b-form-group 
              label-cols="2"
              label="Months before re-certification"
              class="col-12"
            >
              <b-form-input  
                id="gdq_vat" 
                class="form-control col-1"
                v-model="gdq_recertification_months"
                v-on:change="savepref('gdq_recertification_months',gdq_recertification_months)" 
                autocomplete="off"
              >
              </b-form-input>
            </b-form-group>
            <div class="col-11">
              <b-form-group label="Popup text for re-certification">
                <vue-editor 
                  v-model="gdq_recertification_text" 
                  :editorToolbar="editortoolbar" 
                  @text-change="savepref('gdq_recertification_text',gdq_recertification_text)"
                ></vue-editor>
              </b-form-group>
            </div>
          </b-row>
        </b-card>
      </b-tab>              
    </b-tabs>
  </div>
</template>
<script>
import DefaultMailTexts from './DefaultMailTexts';
import Maintenance from './Maintenance';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
import { VueEditor } from "vue2-editor";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ['link'],
];
export default {
  name: 'GDQSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    Maintenance,
    DefaultMailTexts,
    Navbar,
    Breadcrumb,
    VueEditor,
  },
  data: function() {
    return {
      editortoolbar: editortools,
      gdqreport_price: 0,
      gdq_vat: 0,
      gdq_recertification_months: 36,
      gdq_recertification_text: 'You must re-certify!',
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqreport_price' })
      .then((resp) => {
        this.gdqreport_price = resp.data.value;
      });
      this.$store.dispatch('syspref_fetch', { key: 'gdq_vat' })
      .then((resp) => {
        this.gdq_vat = resp.data.value;
      });
      this.$store.dispatch('syspref_fetch', { key: 'gdq_recertification_months' })
      .then((resp) => {
        this.gdq_recertification_months = resp.data.value;
      });
      this.$store.dispatch('syspref_fetch', { key: 'gdq_recertification_text' })
      .then((resp) => {
        this.gdq_recertification_text = resp.data.value;
      });
    },
  },
}
</script>
<style>
</style>
